import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion"; // Adicionado AnimatePresence
import { 
  ArrowLeft, Crown, Zap, Check, ExternalLink, Sparkles, Lock, PartyPopper, ShieldCheck
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner"; // Adicionado o toast

// 1. Atualize o array plans (adicione billingNote)
const plans = [


   {
    id: "pix_31",
    name: "Acesso Avulso (31 dias)",
    price: "R$9,90",
    billingNote: "PAGAMENTO ÚNICO",
    pricePerMonth:  "Sem renovação",
    tagline: "Pague e use! Você pode acumular meses. ⚡",
    savings: "Sem compromisso",
    checkoutUrl: "#", // Link removido pois agora é gerado dinamicamente
    recommended: true,
    cta: "Garantir +31 dias"
  },
  {
    id: "monthly",
    name: "Modo Piloto Automático",
    price: "R$ 9,90",
    billingNote: "ASSINATURA MENSAL",
    pricePerMonth: "Renovação Automática",
    tagline: "O Mercado Pago cuida da renovação por você.",
    savings: "Mais Prático",
    checkoutUrl: "https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=83a3e9ad56e4481dac6055c5c2f95333",
    recommended: false,
    cta: "Ativar renovação automática"
  },

 
];

export default function ProfilePayment() {
  const { userProfile, isPaidUser, planExpiresAt } = useAuth();
  const isRecurring = userProfile?.isRecurring || false;
  const planStatus = userProfile?.planStatus || "free";
  const currentPlan = userProfile?.plan || "free";
  const isReturningFromPayment = new URLSearchParams(window.location.search).get('success') === 'true';
  const activePlanDetails = plans.find(p => p.id === currentPlan);
  const activePlanName = activePlanDetails ? activePlanDetails.name : "Premium";

  // Apos voltar do MP, aguarda 5s (webhook processar) e recarrega sem query string pra forcar refetch do user
  useEffect(() => {
    if (!isReturningFromPayment) return;
    const timer = setTimeout(() => {
      window.location.href = '/profile';
    }, 5000);
    return () => clearTimeout(timer);
  }, [isReturningFromPayment]);

const handleSelectPlan = async (plan) => {
  const userId = userProfile?.uid;

  if (!userId) {
    toast.error("Identificação necessária.");
    return;
  }

  // Se for o plano de PIX, pedimos um link novo pro servidor
  if (plan.id === 'pix_31') {
    toast.info("Preparando ambiente de pagamento...");
    try {
      const { getFunctions, httpsCallable } = await import('firebase/functions');
      const functions = getFunctions();
      const createPixPreference = httpsCallable(functions, 'createPixPreference');
      
      const result = await createPixPreference({});
      window.location.href = result.data.checkoutUrl;
      return; // Para a execução aqui
    } catch (error) {
      toast.error(`Erro: ${error.message || "Tente novamente"}`);
      return;
    }
  }

  // Para assinaturas: chama Cloud Function que cria preapproval via API (Opcao C - 100% determinístico)
  toast.info("Conectando ao Mercado Pago...");
  try {
    const { getFunctions, httpsCallable } = await import('firebase/functions');
    const functions = getFunctions();
    const createSubscriptionPreference = httpsCallable(functions, 'createSubscriptionPreference');
    const result = await createSubscriptionPreference({
      planId: plan.id,
      payerEmail: userProfile?.email,
    });
    window.location.href = result.data.checkoutUrl;
  } catch (err) {
    console.error('Erro ao criar assinatura:', err);
    toast.error('Erro: ' + (err.message || 'Tente novamente em instantes'));
  }
};

  return (
    <div className="min-h-screen bg-[#f8fafc] pb-20">
      
      {/* BANNER DE SINCRONIZAÇÃO ADICIONADO ABAIXO */}
      <AnimatePresence>
        {isReturningFromPayment && (
          <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -50 }}
            className="bg-emerald-600 text-white px-6 py-4 text-center text-sm font-bold shadow-xl flex items-center justify-center gap-2 relative z-50"
          >
            <Sparkles className="w-5 h-5 animate-pulse text-amber-300" />
            <div className="flex flex-col items-center">
              <span>Pagamento recebido! Atualizando seu plano... 🐷</span>
              <div className="w-full h-1 bg-white/20 mt-2 rounded-full overflow-hidden">
                <motion.div 
                  initial={{ width: 0 }}
                  animate={{ width: "100%" }}
                  transition={{ duration: 5 }}
                  className="h-full bg-amber-300"
                />
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <div className="max-w-md mx-auto px-6 py-8">
        
        {/* Header Ácido */}
        <motion.header
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-8"
        >
          <div className="flex justify-between items-center mb-6">
            <Link to="/profile">
              <Button variant="ghost" size="icon" className="rounded-full bg-white shadow-sm border">
                <ArrowLeft className="w-5 h-5" />
              </Button>
            </Link>
            <div className="bg-primary/10 px-3 py-1 rounded-full border border-primary/20">
               <span className="text-[10px] font-bold text-primary uppercase tracking-wider">Upgrade de Conta</span>
            </div>
            <div className="w-10" /> {/* Spacer */}
          </div>
          
          <h1 className="text-3xl font-black tracking-tight text-slate-900 mb-2">
           Seu dinheiro, suas regras!
          </h1>
          <p className="text-slate-500 text-sm italic">
            Acesso completo em todos os planos. A única diferença é quem lembra da renovação: você ou o Troquinho.
          </p>
        </motion.header>

        {isPaidUser && (
  <motion.div 
    initial={{ opacity: 0, scale: 0.95 }}
    animate={{ opacity: 1, scale: 1 }}
    className={`rounded-[24px] p-6 mb-8 shadow-xl relative overflow-hidden text-white border-none ${
      planStatus === 'cancelled_pending' ? "bg-slate-700" : "bg-slate-900"
    }`}
  >
    <div className="absolute top-0 right-0 p-4 opacity-10">
      <Crown className="w-16 h-16 text-white" />
    </div>
    
    <div className="flex items-center gap-3 mb-6">
      <div className={`${planStatus === 'cancelled_pending' ? "bg-slate-500" : "bg-amber-400"} p-2 rounded-xl`}>
        {planStatus === 'cancelled_pending' ? (
          <ShieldCheck className="w-5 h-5 text-white" />
        ) : (
          <Crown className="w-5 h-5 text-slate-900 fill-slate-900" />
        )}
      </div>
      <div>
        <h4 className="font-black text-white text-sm uppercase tracking-tight">
          {planStatus === 'cancelled_pending' ? 'Assinatura Cancelada' : 
           isRecurring ? 'Assinatura Ativa' : 'Acesso Premium Ativo'}
        </h4>
        <p className="text-[11px] text-slate-400 font-medium italic">
          {planStatus === 'cancelled_pending' ? 'Você ainda tem acesso até o fim do período.' : 'Você é patrão no Troquinho! 🐷'}
        </p>
      </div>
    </div>
    
    <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 flex justify-between items-center mb-4 border border-white/5">
      <span className="text-[11px] font-bold text-slate-300 uppercase tracking-wider">
        {isRecurring && planStatus !== 'cancelled_pending' ? 'Próxima renovação:' : 'Acesso válido até:'}
      </span>
      <span className={`text-sm font-black ${planStatus === 'cancelled_pending' ? "text-white" : "text-amber-400"}`}>
        {planExpiresAt ? planExpiresAt.toLocaleDateString('pt-BR') : '---'}
      </span>
    </div>

    {/* Nota inteligente sobre o status */}
    <p className="text-[12px] text-slate-400 text-center mb-4 px-2 leading-tight">
      {planStatus === 'cancelled_pending' 
        ? "Sua assinatura não será renovada. Na data acima, o porquinho fecha o cofre. Mas você pode voltar quando quiser com assinatura ou pagamento único."
        : isRecurring 
          ? "Renovação automática ativa. Cobrança via Mercado Pago."
          : "Pagamento único. Sem cobranças automáticas após o vencimento."}
    </p>

    <div className="space-y-3 text-center border-t border-white/10 pt-4">
      {isRecurring && planStatus !== 'cancelled_pending' ? (
        <a 
          href="https://www.mercadopago.com.br/subscriptions" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-[11px] font-bold text-white/60 hover:text-white flex items-center justify-center gap-1 transition-colors underline decoration-dotted"
        >
          Gerenciar ou Cancelar no Mercado Pago
        </a>
      ) : planStatus === 'cancelled_pending' ? (
        <span className="text-[10px] font-bold text-slate-400 uppercase">Acesso garantido pelo período já pago</span>
      ) : null}
    </div>
  </motion.div>
)}

        {/* 2. LISTA DE PLANOS REORGANIZADA */}
        <div className="space-y-4">
          {plans.map((plan) => (
            <motion.div
              key={plan.id}
              whileTap={{ scale: 0.98 }}
              className={`relative bg-white rounded-[24px] p-6 transition-all border-2 ${
                plan.recommended 
                   ? "border-primary shadow-xl shadow-primary/10 z-10 scale-[1.02] md:scale-105" 
                    : "border-slate-200 opacity-80 hover:opacity-100"
              }`}
            >
              {plan.recommended && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary text-white text-[10px] font-black px-4 py-1 rounded-full uppercase tracking-tighter">
                   Sem Preocupações
                </div>
              )}

              <div className="flex justify-between items-start mb-4">
                <div>
                  <h3 className={`font-black text-xl ${plan.recommended ? "text-primary" : "text-slate-900"}`}>
                    {plan.name}
                  </h3>
                  <p className="text-[11px] font-medium text-slate-400 mt-0.5">{plan.tagline}</p>
                </div>
                <div className="text-right">
                      <p className="text-2xl font-black text-slate-900 leading-none">{plan.price}</p>
                      <p className="text-[9px] text-slate-400 font-medium italic mt-1 uppercase tracking-tighter">
                        {plan.billingNote}
                      </p>
                      <p className="text-[10px] font-bold text-emerald-600 uppercase tracking-tighter mt-1">{plan.savings}</p>
                    </div>
              </div>

              <div className="flex items-center gap-2 mb-4 bg-slate-50 p-2 rounded-lg w-fit">
                <Zap className="w-3 h-3 text-amber-500 fill-amber-500" />
                <span className="text-xs font-bold text-slate-600">{plan.pricePerMonth}</span>
              </div>
              
   <Button
  onClick={() => handleSelectPlan(plan)}
  disabled={
     // 1. Só bloqueia o botão de assinatura se ela já estiver ativa (pra não assinar duas vezes)
    (plan.id === 'monthly' && currentPlan === 'monthly' && planStatus !== 'cancelled_pending') ||
    // 2. Se for assinante ativo, pode desabilitar o PIX se você não quiser que ele pague extra
    (isRecurring && plan.id === 'pix_31' && planStatus === 'active')
  } 
  className={`w-full h-12 rounded-xl font-black text-md transition-all ${
    plan.recommended
      ? "bg-primary hover:bg-primary/90 text-white shadow-lg shadow-primary/20"
      : "bg-slate-100 hover:bg-slate-200 text-slate-600 border border-slate-200"
  } ${
    // Estilo de "Plano Atual"
    (currentPlan === plan.id && planStatus !== 'cancelled_pending') 
      ? "bg-slate-900 text-white border-none opacity-100 shadow-none cursor-default font-bold" 
      : ""
  }`}
>
  {currentPlan === plan.id && planStatus !== 'cancelled_pending' ? (
    <>
      <Check className="w-5 h-5 mr-2" />
      Seu plano atual
    </>
  ) : (isRecurring && plan.id === 'pix_31' && planStatus === 'active') ? (
    <>
      <ShieldCheck className="w-4 h-4 mr-2" />
      Já incluso na assinatura
    </>
  ) : (
    <>
      {plan.cta}
      <ExternalLink className="w-4 h-4 ml-2" />
    </>
  )}
</Button>

{/* ADICIONE ESTE BLOCO ABAIXO DO BOTÃO */}
{plan.id === 'monthly' && currentPlan !== 'monthly' && (
  <p className="text-[10px] text-slate-400 text-center mt-2 px-4 leading-tight">
    *Para renovar automaticamente, seu e-mail do Mercado Pago precisa ser o mesmo do Troquinho.
  </p>
)}

            </motion.div>
          ))}
        </div>

        {/* Rodapé de Segurança & Humor */}
        <motion.footer 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="mt-10 text-center space-y-6"
        >
          <div className="flex flex-col items-center gap-2">
            <div className="flex items-center gap-2 py-2 px-4 bg-secondary/50 rounded-full border border-border">
              <Lock className="w-3 h-3 text-slate-400" />
              <span className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">
                Pagamento seguro via Mercado Pago
              </span>
            </div>
            <p className="text-[11px] text-slate-400 italic px-8">
              "Cancelamento tão fácil que até seu ex conseguiria fazer. Sem letras miúdas, sem drama."
            </p>
          </div>

          <div className="pt-4 border-t border-slate-200">
             <span className="text-[10px] text-slate-300 font-medium tracking-[0.3em] uppercase">Troquinho © 2026</span>
          </div>
        </motion.footer>

      </div>
    </div>
  );
}